module.exports = __webpack_public_path__ + "static/media/back-arrow.75b60e0d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/back-arrow.svg
// module id = 872
// module chunks = 21